import { defineKind } from "./base";

/** SoundCloud in the hosted player: an audio widget (nothing to watch full screen). */
export const soundcloud = defineKind({
  id: "soundcloud",
  provider: "soundcloud",
  types: ["SOUNDCLOUD"],
  surface: "embed",
  icon: "audioLines",
  caps: { seekable: true, endsByItself: true, heldWhenHidden: true, castable: true, queueable: true, dockable: true },
  label: (t) => t("cast_item_soundcloud", "SoundCloud"),
  meta: (t) => t("wall_provider_soundcloud", "SoundCloud"),
  slot: { mediaType: "SOUNDCLOUD", fallback: true },
});
